import { Component } from "react";
import ParametrosConsultaAutorizaciones from "../../../componentes/Autorizaciones/ConsultaAutorizaciones/ParametrosConsultaAutorizaciones";
import Layout from "../../../componentes/Comunes/Layout/Layout";

class ConsultaAutorizacion extends Component {
  render() {
    return (
      <Layout>
        <div>
          <ParametrosConsultaAutorizaciones />
        </div>
      </Layout>
    );
  }
}

export default ConsultaAutorizacion;
